import React from "react";

/* tiny helper for copy buttons */
function CopyBtn({ text, label = "Copy" }) {
  const [copied, setCopied] = React.useState(false);
  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {}
  };
  return (
    <button className="stt-btn stt-btn-outline" onClick={onCopy}>
      {copied ? "Copied!" : label}
    </button>
  );
}

function ContactCard({ emoji, title, children, actions }) {
  return (
    <section className="stt-card">
      <h3 className="stt-card-title">{title}</h3>
      <div className="stt-card-body">
        <div className="stt-contact-head">
          <span className="stt-icon" aria-hidden="true">{emoji}</span>
          <div className="stt-contact-body">{children}</div>
        </div>
      </div>
      {actions ? <div className="stt-card-footer">{actions}</div> : null}
    </section>
  );
}

export default function Contact() {
  const instaUrl = "https://instagram.com/soft.tech.talks";
  const instaHandle = "@soft.tech.talks";
  const email = "softtechtalks08@gmail.com";

  return (
    <main className="stt-wrap">
      <header className="stt-hero">
        <div className="stt-pill">Contact • Soft Tech Talks</div>
        <h1 className="stt-h1">Say hello 👋</h1>
        <p className="stt-lead">
          Whether you’re a student, teacher, or curious builder — we’d love to hear from you.
        </p>
      </header>

      <section className="stt-section stt-grid-2">
        {/* Instagram */}
        <ContactCard
          emoji="📷"
          title="Instagram"
          actions={
            <>
              <a className="stt-btn stt-btn-primary" href={instaUrl} target="_blank" rel="noreferrer">
                Open Instagram
              </a>
              <CopyBtn text={instaHandle} label="Copy handle" />
            </>
          }
        >
          <p className="stt-p">
            Follow <a className="stt-link" href={instaUrl} target="_blank" rel="noreferrer">{instaHandle}</a> for
            issue drops, behind-the-scenes, and workshop updates.
          </p>
          <p className="stt-p" style={{marginTop: ".25rem"}}>DMs are open for collabs & questions.</p>
        </ContactCard>

        {/* Email */}
        <ContactCard
          emoji="✉️"
          title="Email"
          actions={
            <>
              <a className="stt-btn stt-btn-primary" href={`mailto:${email}`}>
                Send an email
              </a>
              <CopyBtn text={email} label="Copy email" />
            </>
          }
        >
          <p className="stt-p">
            Prefer email? Reach us at{" "}
            <a className="stt-link" href={`mailto:${email}`}>{email}</a>.
          </p>
          <p className="stt-p" style={{marginTop: ".25rem"}}>We usually reply within 1–2 days.</p>
        </ContactCard>
      </section>

      {/* Mini note */}
      <section className="stt-section stt-card">
        <h3 className="stt-card-title">Speaking & Workshops</h3>
        <div className="stt-card-body">
          <p className="stt-p">
            Want Soft Tech Talks at your college/class? Ping us on Instagram or email with your dates,
            audience size, and topics you want covered.
          </p>
        </div>
      </section>
    </main>
  );
}
